import { render, staticRenderFns } from "./WhatsAppTemplates.vue?vue&type=template&id=5e0d6a6e&scoped=true"
import script from "./WhatsAppTemplates.vue?vue&type=script&lang=js"
export * from "./WhatsAppTemplates.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppTemplates.vue?vue&type=style&index=0&id=5e0d6a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d6a6e",
  null
  
)

export default component.exports